import { render, staticRenderFns } from "./Vehicles.vue?vue&type=template&id=12d08526&scoped=true"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"
import style0 from "./Vehicles.vue?vue&type=style&index=0&id=12d08526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d08526",
  null
  
)

export default component.exports